export default __webpack_public_path__ + "static/media/image-template-col.d5c02183.svg";